import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user, fetchCurrentUser } = useAuthStore();
  const [isFetchingUser, setIsFetchingUser] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !user && !isLoading && !isFetchingUser) {
      setIsFetchingUser(true);
      fetchCurrentUser()
        .catch(() => {
          useAuthStore.getState().logout();
        })
        .finally(() => {
          setIsFetchingUser(false);
        });
    }
  }, [isAuthenticated, user, isLoading, isFetchingUser, fetchCurrentUser]);

  if (isLoading || isFetchingUser || (isAuthenticated && !user)) {
    return (
      <div className="flex justify-center items-center h-screen bg-white dark:bg-neolab-deep-green">
        <Loader2 className="w-12 h-12 text-neolab-green animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
